<template>
  <div id="app" v-cloak>
    <notifications></notifications>
    <BModalOrchestrator />
    <router-view />
    <div v-if="updateExists" class="update-banner" role="alert" aria-live="polite">
      <span>An update is available</span>
      <DefaultButton :labelText="'Update'" @click="refreshApp" />
    </div>
  </div>
</template>
<script>
import { refreshPageMixin } from "@/mixins/refreshPageMixin"
import update from "@/mixins/update"
import DefaultButton from "@/components/DefaultButton"
import { BModalOrchestrator } from "bootstrap-vue-next"

export default {
  mixins: [refreshPageMixin, update],
  components: { BModalOrchestrator, DefaultButton },
  async created() {
    const accessToken = localStorage.getItem("GFB_ACCESS_TOKEN")
    if (accessToken) {
      this.$store.commit("SET_TOKEN", { accessToken })
      this.$store.dispatch("fetchCategories")
    }
    const { data } = await this.$store.dispatch("api/getExpirationHours")
    const expiration_hours = data.data
    this.$store.commit("SET_EXPIRATION_HOURS", { expiration_hours })
  },
}
</script>
<style type="scss">
:root {
  overscroll-behavior: none;
}

.cursor-pointer {
  cursor: pointer;
}

.update-banner {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1080;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--dark-bg);
  color: #fff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
}
</style>
